import clsx from 'clsx';
import { Button, Disclosure, DisclosurePanel, Heading } from 'react-aria-components';

import { MaterialIcon } from '#/shared/components/MaterialIcon';
import { focusRingClassName } from '#/shared/utils/domHelper';

type PaidBreakExceptionCollapsibleProps = {
  defaultExpanded?: boolean;
  children: React.ReactNode;
  title: string;
};

export function PaidBreakExceptionCollapsible({
  defaultExpanded = false,
  children,
  title,
}: PaidBreakExceptionCollapsibleProps) {
  return (
    <Disclosure defaultExpanded={defaultExpanded}>
      {({ isExpanded }) => (
        <>
          <Heading className="flex text-left items-center justify-between w-full text-base text-on-surface-variant">
            <span className="mr-8">{title}</span>
            <Button
              slot="trigger"
              className={clsx(
                'flex items-center justify-center w-32 h-32 hover:text-primary-shade cursor-pointer text-32',
                focusRingClassName,
              )}
            >
              <MaterialIcon
                iconName={isExpanded ? 'expand_less' : 'expand_more'}
                className="text-on-surface !text-32"
              />
            </Button>
          </Heading>
          <DisclosurePanel className="mt-8">{children}</DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
}
